<template>
  <div>
    <el-popover
      ref="elPrpoverRef"
      popper-class="tag-select-popper-7h23rt76"
      placement="bottom-end"
      width="342"
      trigger="click"
    >
      <template #reference>
        <el-badge
          ref="badgeRef"
          :value="newMessageCount"
          :hidden="!(newMessageCount > 0)"
          :max="99"
          class="badge-position"
        >
          <el-button icon="el-icon-chat-dot-round" type="text" @click="onClickchat"></el-button>
        </el-badge>
      </template>
      <div class="pop-box m-0 flex flex-col p-0">
        <div class="chat-message-title flex items-center justify-between px-12px">
          <div class="py-12px">消息通知{{ newMessageCount > 0 ? `(${newMessageCount})` : '' }}</div>
          <el-link :underline="false" type="primary" @click="allMarkRead">一键已读</el-link>
        </div>
        <div v-if="newMessageCount > 0" class="chat-message-list flex-1 p-16px">
          <ChatMessageItem v-for="item in unReadList" :key="item.id" class="chat-message-item" :message="item" />
        </div>
        <div v-else class="h-200px flex items-center justify-center">
          <span>- 没有新通知 -</span>
        </div>
        <div class="flex items-center justify-center bg-gray-100 py-10px">
          <el-link :underline="false" type="primary" class="float-right" @click="showAllMessage">查看全部通知</el-link>
        </div>
      </div>
    </el-popover>

    <cat-dialog
      width="800px"
      :visible.sync="moreMessagePageVisible"
      :fullscreen="true"
      :hasFullscreen="true"
      :has-footer="false"
    >
      <div class="h-85vh px-1/10">
        <Message />
      </div>
    </cat-dialog>
  </div>
</template>

<script setup lang="ts">
import ChatMessageItem from './ChatMessageItem.vue';
import Message from '@/views/system/userSetting/message/index.vue';

const messageStore = useSysMessageStore();
const { unReadList, newMessageCount } = storeToRefs(messageStore);
const { allMarkRead } = messageStore;

const badgeRef = ref<any>();
const elPrpoverRef = ref<any>();
const badgeElement = ref<any>();

// 新消息，图标闪一闪
watch(
  () => newMessageCount,
  () => {
    badgeElement.value = badgeRef.value?.$el?.querySelector('.el-badge__content');
    if (badgeElement.value) {
      badgeElement.value.classList.add('badge-bilibili-423tui42y');
      setTimeout(() => {
        badgeElement.value.classList.remove('badge-bilibili-423tui42y');
      }, 3000);
    }
  },
  { immediate: true },
);

function onClickchat() {}

const moreMessagePageVisible = ref<boolean>(false);

/**
 * 跳转查看全部消息页面
 */
function showAllMessage() {
  elPrpoverRef.value.doClose();
  moreMessagePageVisible.value = true;
}
</script>

<style lang="scss" scoped>
.pop-box {
  .chat-message-title {
    border-bottom: 1px solid #e6e8ee;
  }

  .chat-message-list {
    max-height: 60vh;
    overflow-y: auto;

    .chat-message-item:not(:first-child) {
      padding-top: 33px;
    }
  }
}

.badge-position :deep .el-badge__content {
  margin-top: 8px;
  margin-right: 12px;
}
</style>

<style lang="scss">
.el-popover.tag-select-popper-7h23rt76 {
  top: 56px !important;
  padding: 0;
  overflow: hidden;
  border-radius: 4px;
  border: 1px solid #e6e8ee;
  box-shadow: 0 0 6px #57678b47;
  background-color: white;
}

.badge-bilibili-423tui42y {
  margin-top: 29px;
  animation: alternate 0.5s infinite badge-belingbeling-3fa76g2376g;
}

@keyframes badge-belingbeling-3fa76g2376g {
  50% {
    background-color: red;
  }
}
</style>
